import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Group, LeftBar, HeaderBlock, LeftBarView, OverLayDiv, TaskDetailContainer, DropDiv, Icons } from './styles';
import {
  archiveBulkTasks,
  dispatchTaskSuccess,
  getFigmaPreviewUrl,
  getMyTaskDetailsData,
  getTaskGroupList,
  getTimelogData,
  updateBulkStatus,
  updateTaskComment,
  updateTaskDetails
} from '../../../../services/taskServices';
import { useHistory, useParams } from 'react-router-dom';
import { StatusListInterface, UserInterface } from '../../../../interfaces/ProjectInterface';
import {
  isEmpty,
  isMediaRecordingSupported,
  getUTCDate,
  removeFileFromFirebase,
  buildCommentUploadFolder
} from '../../../../helpers/common';
import UserPreferenceSingleton from '../../../../helpers/userPreferenceSingleton';
import {
  addTimeLogDetails,
  getActiveTime,
  startTracker,
  updateTimeLogDetails
} from '../../../../services/timeTrackingServices';
import DeleteModal from '../../../../component/modals/deleteModal';
import { nanoid } from 'nanoid';
import {
  COMMENT_TYPE,
  DRAFT_MESSAGE_TYPE,
  FILE_TYPES,
  ICON_BUTTON_SIZE,
  ICON_BUTTON_TYPE,
  LINK_FILE_DATA,
  MENU_OPTIONS,
  STATUS_TYPE
} from '../../../../global/constants';
import Modal from '../../../../component/modals/modal';
import Commentmodal from '../../../../component/modals/commentModal';
import { CommentFilesInterface, TaskCommentsHandle, TaskGroupInterface } from '../../../../interfaces/TaskInterface';
import MilestoneModal from '../../../../component/modals/milestoneModal';
import { trackAnalyticActivity } from '../../../../services/analyticsService';
import ConfirmationModal from '../../../../component/modals/confirmationModal';
import { captureException } from '../../../../services/logService';
import SnapRecordModal from '../../../../component/modals/snapRecordModal';
import { useMobileDevice } from '../../../../global/useMobile';
import RightBlock from './rightBlock';
import SubtaskPopup from '../../../../component/subTaskPopup';
import AppLoading from '../../../../component/loading/appLoading';
import { TASK_ANALYTICS } from '../../../../global/analyticsConstants';
import copy from 'clipboard-copy';
import TaskInfo from './taskInfo';
import TaskComments from './taskComments';
import { Dropdown, DropdownItem } from '../../../../component/dropdown';
import DraftMessageCacheService from '../../../../services/draftMessageCacheService';
import LinkFileModal from '../../../../component/modals/linkFileModal';
import Drawer from '../../../../component/customDrawer';
import { rootStore } from '../../../../mobx/rootStore';
import { TiptapEditorRef } from '../../../../interfaces/tiptapInterface';
import { TaskModel } from '../../../../mobx/models/task';
import { checkSubtaskStatus, dispatchTaskUpdates, onUpdateStatus } from '../../../../services/taskActionService';
import { observer } from 'mobx-react-lite';
import { reaction } from 'mobx';
import CreateTaskModalV2 from '../../../../component/modals/createTaskModal';
import { CommentModel } from '../../../../mobx/models/comment';
import { getCurrentProjectDetails, getMilestoneList } from '../../../../services/projectServices';
import RenderExistingFileV2 from '../../../../component/renderExistingFile';
import BottomSubNavigation from '../../../../component/bottomNavigation/subNavigation';
import { menuTaskDetailItems } from '../../../../global/row';
import BottomNavigationItem from '../../../../component/bottomNavigation/subNavigation/bottomNavigationItem';
import { getVercelDeployment } from '../../../../services/vercelService';
import IconButton from '../../../../component/button/iconButton';
import { RawProjectFile } from '../../../../mobx/interfaces/project';
import BulkActionControls from '../../../../component/bulkActionControls';
import { useHotkeys } from 'react-hotkeys-hook';
import { ROUTES } from '../../../../routes/urls';
import { DesktopHeader, MobileTaskTitle } from './taskHeader';

interface Props {
  taskId?: string;
  projectId?: string;
  isTaskDetailPreview?: boolean;
  onClosePreviewModal?: () => void;
}

const TaskDetail: React.FC<Props> = (props) => {
  const { isTaskDetailPreview, onClosePreviewModal } = props;

  // Refs
  const inlineRef = useRef<TiptapEditorRef>(null);
  const taskCommentsRef = useRef<TaskCommentsHandle>(null);
  const prevTaskIdRef = useRef<string | undefined>();
  const hoveredSubTaskId = useRef<string>('');
  // Holds the latest task name without causing TaskDetail to track the observable.
  // Updated via a MobX reaction so it is always current when handleCopyGitBranch is invoked.
  const taskNameRef = useRef<string>('');

  // States
  const [loading, setLoading] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState<CommentFilesInterface[]>([]);

  const [comment, setComment] = useState<string>('');
  const [alertModelOpen, setAlertModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [alertLoading, setAlertLoading] = useState(false);
  const [isEstimateDropdownOpen, setIsEstimateDropdownOpen] = useState(false);
  const [isOpenComment, setIsOpenComment] = useState(false);
  const [attachment, setAttachment] = useState(false);
  const [figmaRefreshLoading, setFigmaRefreshLoading] = useState<string | null>(null);
  const [deleteCommentId, setDeleteCommentId] = useState<string | null>(null);
  const [isProjectChanged, setIsProjectChanged] = useState(false);
  const [isMilestonemodelopen, setIsMilestonmodelopen] = useState(false);
  const [deleteModelOpen, setDeleteModelopen] = useState(false);
  const [open, setOpen] = useState(false);
  const [isFromSubList, setIsFromSubList] = useState(false);
  const [selectedTaskId, setSelectedTaskId] = useState('');
  const [isConfirmationModelOpen, setIsConfirmationModelOpen] = useState(false);
  const [confirmationLoading, setConfirmationLoading] = useState(false);
  const [status, setStatus] = useState<StatusListInterface>();
  const [previousStatus, setPreviousStatus] = useState<StatusListInterface>();
  const [cancelLoading, setCancelLoading] = useState(false);
  const [currentTask, setCurrentTask] = useState<TaskModel | null>(null);
  const [selectFile, setSelectFile] = useState<boolean>(false);
  const [isCommentModal, setIsCommentModal] = useState<boolean>(false);
  const [subTaskOpen, setSubTaskOpen] = useState<boolean>(false);

  const [isOpen, setIsOpen] = useState(false);

  const [selectedSubTaskIds, setSelectedSubTaskIds] = useState<{ taskId: string; groupId: string }[]>([]);
  const [subTaskBulkDeleteModalOpen, setSubTaskBulkDeleteModalOpen] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [isHoverSelect, setHoverSelect] = useState<boolean>(true);

  //mobx store variables
  const { appStore, timeTrackingStore } = rootStore;
  const { isBubbleMenuOpen } = appStore;
  const { activeTimeLogs } = timeTrackingStore;

  // Other variables
  const history = useHistory();
  const params: { id: string; taskId: string } = useParams();
  const taskId = isEmpty(props?.taskId) ? params?.taskId : props?.taskId;
  const projectId = isEmpty(props?.projectId) ? params?.id : props?.projectId;
  const mobile = useMobileDevice();
  const currentUser = UserPreferenceSingleton.getInstance().getCurrentUser();

  //Mobx store variables
  const { taskStore, workspaceStore, projectStore, currentUser: userDetails } = rootStore;
  const { currentTask: taskDetails } = taskStore;
  const { currentProject } = projectStore;
  const subTaskList = useMemo(() => taskDetails?.subTasks, [taskDetails?.subTasks]);
  const { currentWorkspace: workspace } = workspaceStore;

  const Cancel = useCallback(() => {
    setIsOpenComment(false);
    taskCommentsRef.current?.resetCommentState();
  }, []);

  const loadData = useCallback(async () => {
    if (isEmpty(workspace?.id) || isEmpty(projectId) || isEmpty(taskId)) {
      return;
    }

    if (projectId && rootStore.projectStore.currentProject?.id !== projectId) {
      await getCurrentProjectDetails(projectId);
      rootStore.projectStore.setCurrentProject(projectId);
    }

    const projectDetails = rootStore.projectStore.currentProject;
    const validUser = projectDetails?.usersIds?.find((userId) => userId === currentUser?.id);
    if (!validUser) {
      history.push(ROUTES.INBOX);
      return;
    }

    if (taskId) rootStore.taskStore.setCurrentTask(taskId);
    const draftMessage = await DraftMessageCacheService.getInstance()?.getCurrentDraftMessage(taskId as string);
    if (inlineRef.current) {
      if (draftMessage) {
        inlineRef.current.addContent(draftMessage.message);
        setComment(draftMessage.message);
        setUploadedFiles(draftMessage.file);
      } else {
        inlineRef.current.addContent('');
        setUploadedFiles([]);
      }
    }
    let promises = [getMyTaskDetailsData(taskId)];

    if (isEmpty(workspace?.customerRole)) {
      promises.push(getTimelogData(projectId, taskId, true));
    }
    if (rootStore.settingStore.settingIntegration?.vercel_connected && projectDetails?.vercelProject?.id) {
      promises.push(getVercelDeployment(projectId, taskId));
    }
    if (projectDetails?.isGroupEnabled && isEmpty(projectDetails?.taskGroups)) {
      promises.push(getTaskGroupList(projectDetails?.id));
    }
    if (projectDetails?.isMilestone && isEmpty(projectDetails?.milestones)) {
      promises.push(getMilestoneList(projectDetails?.id, false, true));
    }

    const result = await Promise.all(promises);
    // Check against projectId instead of params.id since that's what we're using
    if (result[0]?.ProjectId !== projectId || isEmpty(result[0])) {
      rootStore.alertNotificationStore.setErrorMessage('Task not found.');
      history.push(ROUTES.INBOX);
    }
  }, [workspace?.id, workspace?.customerRole, projectId, taskId, currentUser?.id, history]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  // Clear reply and comment states only when navigating to a different task
  useEffect(() => {
    if (prevTaskIdRef.current && prevTaskIdRef.current !== taskId) {
      taskCommentsRef.current?.resetCommentState();
      setIsOpenComment(false);
    }
    prevTaskIdRef.current = taskId;
  }, [taskId]);

  useEffect(() => {
    return () => {
      rootStore.taskStore.clearCurrentTask();
    };
  }, []);

  // Keep taskNameRef in sync with the MobX observable without accessing it in the render phase.
  // Using reaction() instead of a useEffect dep ensures TaskDetail never tracks taskDetails.name.
  useEffect(() => {
    const dispose = reaction(
      () => rootStore.taskStore.currentTask?.name,
      (name) => {
        taskNameRef.current = name || '';
      },
      { fireImmediately: true }
    );
    return dispose;
  }, []);

  // Helper function to update comments in Redux
  const updateCommentInState = useCallback(
    (updatedHtmlString: string, comment: CommentModel) => {
      // Only the text changes here, so carry over the rest of the comment.
      taskDetails?.upsertComment({
        id: comment?.id,
        comment: updatedHtmlString,
        updatedTime: new Date().toISOString(),
        createdBy: comment?.createdById,
        updatedBy: comment?.createdById,
        type: COMMENT_TYPE.COMMENT,
        createdOn: comment?.createdOn.toISOString(),
        Files: comment?.Files,
        reactions: comment?.reactions,
        reply: comment?.replyId
      });
    },
    [taskDetails]
  );

  // Helper function to parse comment HTML
  const getCommentBody = useCallback((commentHtml: string) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(commentHtml, 'text/html');
    return doc.querySelector('body');
  }, []);

  // Helper function to add/remove animation
  const toggleRefreshAnimation = useCallback((body: HTMLElement, isSpin: boolean) => {
    const refreshIcon = body.querySelector('.refresh-icon');
    if (refreshIcon) {
      if (isSpin) {
        refreshIcon.classList.add('refresh-icon-spin');
      } else {
        refreshIcon.classList.remove('refresh-icon-spin');
      }
    }
  }, []);

  // for open model
  const openModel = useCallback(() => {
    setIsOpen(true);
  }, []);

  // for cancel model
  const cancelModel = useCallback(() => {
    setIsOpen(false);
  }, []);

  const onClickCheckBox = useCallback(
    async (body: HTMLBodyElement | null, htmlElement: HTMLElement | null | undefined, comment: CommentModel) => {
      if (!htmlElement || !body) return;
      // Extract div content from htmlElement
      const htmlElementDiv = htmlElement.querySelector('div');
      if (!htmlElementDiv) return;

      const htmlElementDivHTML = htmlElementDiv.innerHTML.trim();

      // Find matching li in the parsed body
      const matchingLi = Array.from(body.querySelectorAll('li[data-type="taskItem"]')).find((li) => {
        const liDiv = li.querySelector('div');
        return liDiv && liDiv.innerHTML.trim() === htmlElementDivHTML;
      });

      if (matchingLi) {
        const input = matchingLi.querySelector('input[type="checkbox"]');
        if (input) {
          if (input.hasAttribute('checked')) {
            matchingLi.setAttribute('data-checked', 'false');
            input.removeAttribute('checked'); // Remove checked if it exists
          } else {
            matchingLi.setAttribute('data-checked', 'true');
            input.setAttribute('checked', 'true'); // Add checked without a value
          }
        }
      }
      const updatedHtmlString = body.innerHTML;
      updateCommentInState(updatedHtmlString, comment);
      await updateTaskComment(taskId, comment?.id, { Comment: updatedHtmlString });
    },
    [taskId, updateCommentInState]
  );

  // Helper function to extract Figma fileId and nodes
  const extractFigmaUrlData = useCallback((figmaUrl: string) => {
    const url = new URL(figmaUrl);
    return { fileId: url.pathname.split('/')[2], nodes: url.searchParams.get('node-id') };
  }, []);

  const onClickHandleRichtextClick = useCallback(
    async (event: React.MouseEvent, item: CommentModel) => {
      try {
        const clickedElement = event.target as HTMLElement;
        const body = getCommentBody(item?.comment || '');
        if (!body) return;
        const subParentElement = clickedElement.parentElement;
        const parentElement = subParentElement?.parentElement;
        if (
          parentElement &&
          parentElement.tagName.toLowerCase() === 'li' &&
          parentElement.getAttribute('data-type') === 'taskItem'
        ) {
          onClickCheckBox(body, parentElement, item);
        }
      } catch (e) {
        captureException(e);
      }
    },
    [getCommentBody, onClickCheckBox]
  );

  const onClickHandleRefreshFigma = useCallback(
    async (item: CommentModel, figmaURL: string) => {
      try {
        setFigmaRefreshLoading(item?.id);
        const body = getCommentBody(item?.comment || '');
        if (!body) return;
        const { fileId, nodes } = extractFigmaUrlData(figmaURL);
        const figmaData = await getFigmaPreviewUrl({ fileId, nodes });
        if (!figmaData) return;

        const containers = Array.from(body.querySelectorAll('.figma-main-div')) as HTMLElement[];
        const container = containers.find((c) => c.getAttribute('url') === figmaURL) || null;
        const previewImage = container?.querySelector('.figma-preview-image') as HTMLImageElement | null;
        if (previewImage) {
          previewImage.src = figmaData?.filePreviewUrl || '';
        }
        // Always update container attributes so RenderHtml -> FigmaEmbedCard receive new props
        if (container) {
          container.setAttribute('filepreviewurl', figmaData?.filePreviewUrl || '');
          container.setAttribute('framenames', figmaData?.frameNames || '');
          container.setAttribute('projectname', figmaData?.projectName || '');
        }

        const description = container?.querySelector('.figma-description');
        if (description) {
          description.textContent = figmaData?.frameNames;
        }

        toggleRefreshAnimation(body, false);

        const filename = container?.querySelector('.figma-filename');
        if (filename) {
          filename.textContent = figmaData?.projectName || '';
        }

        const updatedHtmlString = body.innerHTML;
        updateCommentInState(updatedHtmlString, item);
        const result = await updateTaskComment(taskId, item?.id, { Comment: updatedHtmlString });
        if (result) await getMyTaskDetailsData(taskId);
      } catch (e) {
        captureException(e);
      } finally {
        setFigmaRefreshLoading(null);
      }
    },
    [extractFigmaUrlData, getCommentBody, taskId, toggleRefreshAnimation, updateCommentInState]
  );

  const Opendeletemodel = (taskId: string, subTask = false) => {
    setDeleteModelopen(true);
    setSelectedTaskId(taskId);
    setIsFromSubList(subTask);
  };

  const close = () => {
    setDeleteModelopen(false);
    setSelectedTaskId('');
    setIsFromSubList(false);
  };

  const closeAlertModal = () => {
    setAlertModalOpen(false);
  };

  const isClosemodel = () => {
    setIsMilestonmodelopen(false);
  };

  const handleCancel = useCallback(() => {
    setOpen(false);
    rootStore.taskStore.createTaskInput.clear();
    setIsFromSubList(false);
  }, []);

  //on click edit task
  const onClickEdit = useCallback(async (taskDetails: TaskModel) => {
    rootStore.taskStore.createTaskInput.updateWith(taskDetails);
    setOpen(true);
  }, []);

  const deleteTask = useCallback(async () => {
    try {
      setLoading(true);
      const payloadTask = { isArchived: true, projectId: currentProject?.id };
      const response = await updateTaskDetails(selectedTaskId, payloadTask);
      setDeleteModelopen(false);
      if (response && !isFromSubList) {
        history.goBack();
      }
      rootStore.taskStore.removeTasks([selectedTaskId]);
    } catch (error) {
      captureException(error);
    } finally {
      setLoading(false);
    }
  }, [currentProject?.id, selectedTaskId, isFromSubList, history]);

  const openDeleteCommentModal = useCallback((commentId: string) => {
    setDeleteCommentId(commentId);
  }, []);

  const closeDeleteCommentModal = useCallback(() => {
    setDeleteCommentId(null);
  }, []);

  const removeComment = useCallback(async () => {
    if (!taskDetails?.comments || !deleteCommentId) return;
    setLoading(true);
    try {
      const commentToDelete = taskDetails?.comments?.find((comment) => comment.id === deleteCommentId);
      const payload = { IsArchived: true };
      const result = await updateTaskComment(taskDetails?.id, deleteCommentId, payload);
      if (result) {
        // Delete only the files uploaded to this comment from Firebase, keep the selected project files.
        commentToDelete?.Files?.forEach((file) => {
          if (file && !file.uploadFileType && file.href?.startsWith('https://firebasestorage.googleapis'))
            removeFileFromFirebase(file.href);
        });
        taskDetails?.removeComment(deleteCommentId);
        trackAnalyticActivity(TASK_ANALYTICS.COMMENT_DELETED);
      }
    } catch (error) {
      captureException(error);
    } finally {
      setLoading(false);
      closeDeleteCommentModal();
    }
  }, [taskDetails, deleteCommentId, closeDeleteCommentModal]);

  const onClickClone = useCallback(async (task: TaskModel) => {
    rootStore.taskStore.createTaskInput.updateWith(task);
    rootStore.taskStore.createTaskInput.setDueDate(null);
    rootStore.taskStore.createTaskInput.setId(undefined);
    // Set cloneTaskId if the task has subtasks
    if (task.subTasks && task.subTasks.length > 0) {
      rootStore.taskStore.createTaskInput.setCloneTaskId(task.id);
    }
    setOpen(true);
  }, []);

  const getFilePath = useCallback((x: CommentFilesInterface, taskDetails: TaskModel | null) => {
    const fileName = x?.name?.replaceAll(' ', '_');
    if (x?.href?.startsWith('/projects/files')) return x?.href;
    if (x?.href?.startsWith('https://') && x?.uploadFileType !== FILE_TYPES.UPLOAD && x?.isCreatedDoc) return x?.href;
    if (
      x?.href?.startsWith('https://') &&
      (x?.uploadFileType === FILE_TYPES.DOCS ||
        x?.uploadFileType === FILE_TYPES.DRIVE ||
        x?.uploadFileType === FILE_TYPES.DROPBOX ||
        x?.uploadFileType === FILE_TYPES.FIGMA ||
        x?.uploadFileType === FILE_TYPES.ONEDRIVE)
    ) {
      return x?.href;
    }
    return `/projects/details/${taskDetails?.projectId}/files/file-view/${encodeURIComponent(
      fileName
    )}?fileUrl=${encodeURIComponent(x?.href)}`;
  }, []);

  // handle File card click in activity
  const handleActivityFileCard = useCallback(
    (e: React.SyntheticEvent, x: CommentFilesInterface) => {
      e.preventDefault();
      const path = getFilePath(x, taskDetails);
      if (
        x?.uploadFileType &&
        [FILE_TYPES.DRIVE, FILE_TYPES.DROPBOX, FILE_TYPES.NOTION, FILE_TYPES.FIGMA, FILE_TYPES.ONEDRIVE].includes(
          x?.uploadFileType
        )
      ) {
        window.open(path, '_blank');
        return;
      } else {
        history.push(path);
      }
    },
    [getFilePath, history, taskDetails]
  );

  const attachmentPage = useCallback(
    (isCommentModal: boolean) => {
      setIsCommentModal(isCommentModal);
      currentProject?.setCurrentFolderId(null);
      if (mobile) {
        setSelectFile(true);
      } else {
        setAttachment(true);
      }
    },
    [mobile, currentProject, setSelectFile, setAttachment]
  );

  useEffect(() => {
    const dropdown = document.querySelector('.dropdown-content');
    if (dropdown && dropdown instanceof HTMLElement) {
      const rect = dropdown.getBoundingClientRect();
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;

      if (rect.bottom + 10 > windowHeight) {
        dropdown.style.top = `-${rect.height + 35}px`;
      } else {
        dropdown.style.top = 'auto';
      }
    }
  }, [isOpenComment]);

  const handleProjectChange = (value: boolean) => {
    setIsProjectChanged(value);
  };

  const onClickBackIcon = useCallback(() => {
    if (isTaskDetailPreview && onClosePreviewModal) {
      onClosePreviewModal();
      history.push(ROUTES.INBOX);
    } else if (isProjectChanged) {
      history.push(ROUTES.PROJECT_TASKS.replace(':id', currentProject?.id || ''));
    } else if (history.length > 1) {
      history.goBack(); // Check if there's enough history to go back
    } else {
      history.push(ROUTES.INBOX); // Default navigation to home if no history exists
    }
  }, [currentProject?.id, history, isProjectChanged, isTaskDetailPreview, onClosePreviewModal]);

  const onClickProjectName = useCallback(() => {
    history.push(ROUTES.PROJECT_TASKS.replace(':id', currentProject?.id || ''));
  }, [currentProject?.id, history]);

  const onClickStopAndStartTime = useCallback(async () => {
    try {
      setAlertLoading(true);
      const date1 = new Date(activeTimeLogs[0]?.TimerStartedAt).getTime();
      const date2 = new Date().getTime();
      const timeDifference = date2 - date1; // Difference in milliseconds
      const hoursDifference = timeDifference / (1000 * 60 * 60);
      const userDetails = UserPreferenceSingleton.getInstance().getCurrentUser();
      const itemId = activeTimeLogs[0]?.['_id'];

      const historyUpdated = activeTimeLogs[0]?.History?.map((history) => {
        const { __typename, ...other } = history;
        return other;
      });

      const historyHoursSum = activeTimeLogs[0]?.History?.reduce((total, historyItem) => {
        return total + (historyItem.Hours || 0);
      }, 0);

      const payloadUpdate = {
        Hours: Number(Number(historyHoursSum || 0) + hoursDifference),
        TimerStartedAtUnset: true,
        History: [
          ...(historyUpdated || []),
          {
            _id: nanoid(),
            CreatedBy: userDetails?.id,
            CreatedTime: new Date().toISOString(),
            UpdatedBy: userDetails?.id,
            UpdatedTime: new Date().toISOString(),
            TimerStartedAt: activeTimeLogs[0]?.TimerStartedAt,
            TimerEndedAt: new Date().toISOString(),
            Hours: hoursDifference
          }
        ]
      };
      await updateTimeLogDetails(itemId, payloadUpdate);

      const payload = {
        project_id: currentProject?.id,
        task_id: taskId,
        date: getUTCDate(new Date()).toISOString(),
        hours: 0,
        startTime: true,
        trackingStartTime: new Date().toISOString()
      };
      const result = await addTimeLogDetails(payload);
      if (result) {
        startTracker(taskId);
        setAlertModalOpen(false);
        rootStore.alertNotificationStore.setSuccessMessage('Time Started!');
        await getTimelogData(projectId, taskId);
        await getActiveTime();
      }
    } catch (error) {
      captureException(error);
      setAlertLoading(false);
    } finally {
      setAlertLoading(false);
    }
  }, [currentProject?.id, projectId, taskId, activeTimeLogs]);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleOpenConfirmationModal = useCallback(() => {
    setIsConfirmationModelOpen(true);
  }, []);

  const closeConfirmationModal = useCallback(() => {
    setIsConfirmationModelOpen(false);
  }, []);

  // handle click for common dropdown
  const handleClick = useCallback(
    (key: number | string) => {
      if (!taskDetails) return;
      key = Number(key);
      if (key === MENU_OPTIONS.EDIT) {
        onClickEdit(taskDetails);
      } else if (key === MENU_OPTIONS.ADDLINK) {
        openModel();
      } else if (key === MENU_OPTIONS.CLONE) {
        onClickClone(taskDetails);
      } else if (key === MENU_OPTIONS.DELETE) {
        Opendeletemodel(taskDetails?.id);
      }
    },
    [onClickClone, onClickEdit, openModel, taskDetails]
  );

  const onChangeStatus = useCallback(
    (task: TaskModel, status: StatusListInterface, previousStatus: StatusListInterface) => {
      const isSubtaskRemaining = checkSubtaskStatus(task);
      if (status.Type === STATUS_TYPE.COMPLETED && !isSubtaskRemaining) {
        handleOpenConfirmationModal();
        setStatus(status);
        setPreviousStatus(previousStatus);
        setCurrentTask(task);
        return;
      }
      onUpdateStatus(task, status, previousStatus, false);
    },
    [handleOpenConfirmationModal]
  );

  //Handle checkbox click when project status is disabled
  const onClickTaskCheckBox = useCallback(
    (task: TaskModel, status: boolean) => {
      const isSubtaskRemaining = checkSubtaskStatus(task);
      if (status && !isSubtaskRemaining) {
        handleOpenConfirmationModal();
        setCurrentTask(task);
        return;
      }
      task.setStatus(status, false);
      dispatchTaskUpdates(task, status);
    },
    [handleOpenConfirmationModal]
  );

  //Handle Yes button click for confirmation model
  const onClickConfirm = useCallback(() => {
    if (!currentTask) return;
    try {
      setConfirmationLoading(true);
      if (currentTask.project?.statusEnable && status && previousStatus) {
        onUpdateStatus(currentTask, status, previousStatus, true);
      } else {
        currentTask.setStatus(true, true);
        dispatchTaskUpdates(currentTask, true);
      }
    } catch (error) {
      captureException(error);
    } finally {
      setConfirmationLoading(false);
      closeConfirmationModal();
    }
  }, [closeConfirmationModal, currentTask, previousStatus, status]);

  //Handle No button click for confirmation model
  const onClickNo = useCallback(() => {
    if (!currentTask) return;
    try {
      setCancelLoading(true);
      if (taskDetails?.project?.statusEnable && status && previousStatus) {
        onUpdateStatus(currentTask, status, previousStatus, false);
      } else {
        currentTask.setStatus(true, false);
        dispatchTaskUpdates(currentTask, true);
      }
    } catch (error) {
    } finally {
      setCancelLoading(false);
      closeConfirmationModal();
    }
  }, [closeConfirmationModal, currentTask, previousStatus, status, taskDetails?.project?.statusEnable]);

  //get file type
  const getFileType = useCallback((uploadFileType?: number, extension?: string) => {
    if (uploadFileType === FILE_TYPES.DOCS) return 'docs';
    if (uploadFileType === FILE_TYPES.WHITEBOARD) return 'white';
    return extension || '';
  }, []);

  const onSelectFile = useCallback(
    async (item: RawProjectFile) => {
      if (!item) return;

      const { name, uploadFileType, parentId, id, size = 0, url = '' } = item;
      const extension = name?.split('.').pop() || '';
      const isDocOrWhiteboard = uploadFileType === FILE_TYPES.DOCS || uploadFileType === FILE_TYPES.WHITEBOARD;

      let fileUrl = url;
      if (isDocOrWhiteboard) {
        fileUrl = `/projects/files/${projectId}/docs/${id}${!isEmpty(parentId) ? `?folder=${parentId}` : ''}`;
      }

      const sizeInMB = (size || 0) / (1024 * 1024);
      const sizeValue = sizeInMB >= 1 ? `${sizeInMB.toFixed(2)} MB` : `${(size / 1024).toFixed(2)} KB`;

      if (['png', 'jpeg', 'jpg'].includes(extension)) {
        inlineRef.current?.addImageInContent(fileUrl);
      } else if (['mp4', 'mov', 'mkv', 'webm'].includes(extension)) {
        inlineRef.current?.addRecordingCard(fileUrl, item?.name);
      } else {
        const newObj: CommentFilesInterface = {
          name,
          href: fileUrl || '',
          size: sizeValue,
          file_type: getFileType(item?.uploadFileType, extension),
          isCreatedDoc: true,
          uploadFileType: Number(item?.uploadFileType)
        };
        const updatedFiles = [...uploadedFiles, newObj];
        setUploadedFiles(updatedFiles);
        // Update draft cache when files are added
        const message = {
          id: taskId,
          type: DRAFT_MESSAGE_TYPE.COMMENT,
          message: comment,
          file: updatedFiles || []
        };
        await DraftMessageCacheService.getInstance()?.addBulk([message]);
      }
    },
    [getFileType, projectId, uploadedFiles, taskId, comment]
  );

  //function will handle copy task link
  const handleCopyTaskLink = useCallback(async () => {
    try {
      const baseUrl = window.location.origin;
      const taskUrl = `${baseUrl}/projects/details/${taskDetails?.projectId}/tasks/details/${taskDetails?.id}`;
      await copy(taskUrl);
      rootStore.alertNotificationStore.setSuccessMessage(`Task URL copied successfully!`);
    } catch (error) {
      captureException(error);
    }
  }, [taskDetails?.id, taskDetails?.projectId]);

  //function will handle copy task number
  const handleCopyTaskNumber = useCallback(async () => {
    try {
      if (taskDetails?.taskNumber) {
        const identifier = taskDetails?.project?.identifier;
        const copyValue = identifier ? `${identifier}-${taskDetails.taskNumber}` : `${taskDetails.taskNumber}`;
        await copy(copyValue);
        rootStore.alertNotificationStore.setSuccessMessage(`"${copyValue}" copied successfully!`);
      }
    } catch (error) {
      captureException(error);
    }
  }, [taskDetails?.taskNumber, taskDetails?.project?.identifier]);

  //format string of github branch
  const formatString = useCallback((input: string) => {
    return (input ?? '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^[-]+/, '')
      .replace(/[-]+$/, '');
  }, []);

  // Function will copy branch name in clipboard
  const handleCopyGitBranch = useCallback(async () => {
    try {
      const userName = userDetails?.email?.split('@')[0] || '';
      const identifier = taskDetails?.project?.identifier?.toUpperCase()?.trim();
      const taskPart = identifier ? `${identifier}-${taskDetails?.taskNumber}` : `${taskDetails?.taskNumber}`;
      const branchName = `${formatString(userName)}/${taskPart}/${formatString(taskNameRef.current)}`;
      await copy(branchName);
      rootStore.alertNotificationStore.setSuccessMessage('Branch copied successfully!');
    } catch (error) {
      captureException(error);
    }
  }, [formatString, taskDetails?.taskNumber, taskDetails?.project?.identifier, userDetails?.email]);

  useEffect(() => {
    setHoverSelect(selectedSubTaskIds.length === 0);
  }, [selectedSubTaskIds.length]);

  const selectInitialSubTask = () => {
    if (!hoveredSubTaskId.current && selectedSubTaskIds.length === 0 && subTaskList && subTaskList.length > 0) {
      const firstSubTask = subTaskList[0];
      setSelectedSubTaskIds([
        {
          taskId: firstSubTask.id,
          groupId: firstSubTask.groupId || ''
        }
      ]);
    }
  };

  const findNextSelectableSubTask = (currentTaskId: string, direction: 'up' | 'down') => {
    const allTasks = [...(subTaskList as TaskModel[])];
    const currentIndex = allTasks.findIndex((task) => task.id === currentTaskId);

    if (currentIndex === -1) return { nextTaskId: null };

    if (direction === 'down') {
      if (currentIndex + 1 < allTasks.length) {
        return { nextTaskId: allTasks[currentIndex + 1].id };
      }
    } else if (direction === 'up') {
      if (currentIndex > 0) {
        return { nextTaskId: allTasks[currentIndex - 1].id };
      }
    }
    return { nextTaskId: null };
  };

  const expandSubTaskSelection = (direction: 'up' | 'down') => {
    let startId = hoveredSubTaskId.current;

    if (!startId && selectedSubTaskIds.length > 0) {
      startId = selectedSubTaskIds[selectedSubTaskIds.length - 1].taskId;
    }

    if (!startId && selectedSubTaskIds.length === 0) {
      selectInitialSubTask();
      return;
    }

    if (startId && selectedSubTaskIds.length === 0) {
      const task = subTaskList?.find((t: TaskModel) => t.id === startId);
      if (task) {
        setSelectedSubTaskIds([{ taskId: startId, groupId: task.groupId || '' }]);
      }
      setHoverSelect(false);
      hoveredSubTaskId.current = '';
      return;
    }

    let currentId = startId;
    let foundNewTask = false;

    for (let i = 0; i < selectedSubTaskIds.length + 1; i++) {
      const next = findNextSelectableSubTask(currentId, direction);
      if (!next.nextTaskId) {
        const firstTaskId = (subTaskList as TaskModel[])?.[0]?.id || '';
        currentId = firstTaskId;
        break;
      }
      currentId = next.nextTaskId;

      const currentTaskId = currentId;
      const index = selectedSubTaskIds.findIndex((item) => item.taskId === currentTaskId);
      if (index === -1) {
        const task = subTaskList?.find((t: TaskModel) => t.id === currentTaskId);
        if (task) {
          selectedSubTaskIds.push({ taskId: currentId, groupId: task.groupId || '' });
        }
        foundNewTask = true;
        break;
      } else if (i > 0) {
        continue;
      }
    }

    if (!foundNewTask && selectedSubTaskIds.length > 0) {
      if (direction === 'down') {
        selectedSubTaskIds.shift();
      } else {
        selectedSubTaskIds.pop();
      }
    }

    setHoverSelect(selectedSubTaskIds.length === 0);
    setSelectedSubTaskIds([...selectedSubTaskIds]);
  };

  useHotkeys('shift+down', async () => {
    const selectedItems = document.querySelectorAll<HTMLElement>('.selected-task');
    selectedItems.forEach(function (item) {
      item.style.borderRadius = '40px';
    });
    expandSubTaskSelection('down');
  });

  useHotkeys('shift+up', async () => {
    const selectedItems = document.querySelectorAll<HTMLElement>('.selected-task');
    selectedItems.forEach(function (item) {
      item.style.borderRadius = '40px';
    });
    expandSubTaskSelection('up');
  });

  const updateBorderRadius = useCallback(() => {
    const selectedItems = document.querySelectorAll<HTMLElement>('.selected-task');
    const numSelectedItems = selectedItems.length;

    selectedItems.forEach(function (item, index) {
      if (numSelectedItems === 1) {
        item.style.borderRadius = '40px';
      } else if (index === 0) {
        item.style.borderRadius = '18px 18px 0 0';
      } else if (index === numSelectedItems - 1) {
        item.style.borderRadius = '0 0 18px 18px';
      } else {
        item.style.borderRadius = '0';
      }
    });
  }, []);

  useEffect(() => {
    document.addEventListener('keydown', updateBorderRadius);
    return () => {
      document.removeEventListener('keydown', updateBorderRadius);
    };
  }, [updateBorderRadius]);

  const resetSelectedItemStyle = useCallback(() => {
    const selectedItems = document.querySelectorAll<HTMLElement>('.selected-task');
    selectedItems.forEach(function (item) {
      item.style.borderRadius = '40px';
    });
  }, []);

  const onRemoveSelectedSubTasks = useCallback(() => {
    resetSelectedItemStyle();
    setSelectedSubTaskIds([]);
    setHoverSelect(true);
  }, [resetSelectedItemStyle]);

  // Esc clears subtask selection unless a modal is open
  useHotkeys('esc', () => {
    if (selectedSubTaskIds.length === 0 || document.querySelector('[role="dialog"]')) return;
    onRemoveSelectedSubTasks();
  });

  const onBulkUpdateSubTaskStatus = useCallback(
    async (
      status: StatusListInterface,
      previousStatus: StatusListInterface,
      subTaskIds: { taskId: string; groupId: string }[]
    ) => {
      const taskIds = subTaskIds.map((t) => t.taskId);
      taskIds.forEach((id) => {
        const taskDetails = rootStore.taskStore.tasks.find((x) => x?.id === id);
        taskDetails?.setStatus(status?.['_id']);
      });
      const comment = {
        Type: COMMENT_TYPE.STATUS_ID_CHANGE,
        Group: status?.Name,
        PreviousGroup: previousStatus?.Name,
        Priority: status?.Type
      };
      const payload = {
        projectId: currentProject?.id,
        taskIds,
        statusId: status?.['_id'],
        status: status?.['_id'] === previousStatus?.['_id'],
        comment
      };
      await updateBulkStatus(payload);
      resetSelectedItemStyle();
      setSelectedSubTaskIds([]);
      if (loadData) loadData();
    },
    [currentProject?.id, loadData, resetSelectedItemStyle]
  );

  // logic for bulk update group
  const onBulkUpdateGroup = useCallback(
    async (
      group: TaskGroupInterface,
      tasks: {
        taskId: string;
        groupId: string;
      }[]
    ) => {
      let promises: Promise<boolean>[] = [];
      tasks.forEach(async (task) => {
        const payloadTask = { groupId: group?.id, projectId: currentProject?.id };
        promises.push(updateTaskDetails(task?.taskId, payloadTask));
      });
      await Promise.all(promises);
      resetSelectedItemStyle();
      setSelectedSubTaskIds([]);
      if (loadData) loadData();
    },
    [currentProject?.id, loadData, resetSelectedItemStyle]
  );

  const onBulkDeleteSubTasks = useCallback(
    async (subTaskIds: string[]) => {
      try {
        setDeleteLoading(true);
        if (!currentProject?.id) return;
        const payload = {
          projectId: currentProject?.id,
          taskIds: subTaskIds
        };
        const result = await archiveBulkTasks(payload);

        if (result) {
          dispatchTaskSuccess('Tasks archived successfully!');
          rootStore.taskStore.removeTasks(subTaskIds);
          setSelectedSubTaskIds([]);
          loadData && loadData();
          setSubTaskBulkDeleteModalOpen(false);
        }
      } catch (e) {
        captureException(e);
      } finally {
        setDeleteLoading(false);
      }
    },
    [currentProject?.id, loadData]
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const renderDropdownItem = () => {
    return (
      <>
        {menuTaskDetailItems.map((item) => (
          <DropdownItem
            label={item.label}
            key={item?.key}
            tone={item.label === 'Delete' ? 'critical' : 'primary'}
            iconName={item.iconName}
            iconTone={'fill'}
            iconSize={16}
            iconViewBox={'0 0 18 18'}
            onClick={() => handleClick(item.key)}
          />
        ))}
      </>
    );
  };

  const renderDropdown = useCallback(() => {
    return (
      <DropDiv>
        <Dropdown
          modalTitle='Manage Task'
          activeClassName='active-state'
          content={
            mobile ? (
              <BottomNavigationItem iconName='three-dots-horizontal-icon' />
            ) : (
              <IconButton
                iconName='three-dots-horizontal-icon'
                size={ICON_BUTTON_SIZE.MEDIUM}
                variant={ICON_BUTTON_TYPE.TERTIARY}
              />
            )
          }
          trigger='click'>
          {renderDropdownItem()}
        </Dropdown>
      </DropDiv>
    );
  }, [mobile, renderDropdownItem]);

  const renderHeaderIcons = useMemo(() => {
    return (
      <Icons>
        {mobile ? (
          <BottomNavigationItem iconName='copy-link-icon' onClick={handleCopyTaskLink} />
        ) : (
          <IconButton
            iconName='copy-link-icon'
            size={ICON_BUTTON_SIZE.MEDIUM}
            variant={ICON_BUTTON_TYPE.TERTIARY}
            onClick={handleCopyTaskLink}
          />
        )}
        {!mobile && (
          <IconButton
            iconName='copy-icon'
            size={ICON_BUTTON_SIZE.MEDIUM}
            variant={ICON_BUTTON_TYPE.TERTIARY}
            onClick={handleCopyTaskNumber}
          />
        )}
        {currentProject?.githubRepository && !mobile && (
          <IconButton
            iconName='github-branch-icon'
            size={ICON_BUTTON_SIZE.MEDIUM}
            variant={ICON_BUTTON_TYPE.TERTIARY}
            onClick={handleCopyGitBranch}
          />
        )}
        {renderDropdown()}
      </Icons>
    );
  }, [
    currentProject?.githubRepository,
    handleCopyGitBranch,
    handleCopyTaskLink,
    handleCopyTaskNumber,
    mobile,
    renderDropdown
  ]);

  const renderActivitySection = taskDetails && (
    <TaskComments
      ref={taskCommentsRef}
      taskId={taskId || ''}
      taskDetails={taskDetails}
      attachmentPage={attachmentPage}
      handleOpenSnapModal={handleOpenModal}
      onClickHandleRefreshFigma={onClickHandleRefreshFigma}
      onClickHandleRichtextClick={onClickHandleRichtextClick}
      handleActivityFileCard={handleActivityFileCard}
      figmaRefreshLoading={figmaRefreshLoading}
      inlineRef={inlineRef}
      isOpenComment={isOpenComment}
      setIsOpenComment={setIsOpenComment}
      comment={comment}
      setComment={setComment}
      uploadedFiles={uploadedFiles}
      setUploadedFiles={setUploadedFiles}
      setAttachment={setAttachment}
      openDeleteCommentModal={openDeleteCommentModal}
    />
  );

  if (selectFile) {
    return (
      <RenderExistingFileV2
        setAttachment={() => setAttachment(false)}
        setSelectFile={(value: boolean) => setSelectFile(value)}
        onSelectFile={onSelectFile}
      />
    );
  }

  if (isTaskDetailPreview && taskDetails?.id !== taskId) {
    return <AppLoading />;
  }

  return (
    <>
      <Group isTaskDetailPreview={isTaskDetailPreview}>
        {mobile && <MobileTaskTitle />}
        <LeftBar isTaskDetailPreview={isTaskDetailPreview}>
          <LeftBarView>
            {!mobile && (
              <DesktopHeader
                onClickBackIcon={onClickBackIcon}
                onClickProjectName={onClickProjectName}
                currentProject={currentProject}
                isTaskDetailPreview={isTaskDetailPreview}
                renderHeaderIcons={renderHeaderIcons}
              />
            )}
            <HeaderBlock isOverflowHidden={isBubbleMenuOpen}>
              <TaskDetailContainer isTaskDetailPreview={isTaskDetailPreview}>
                <TaskInfo
                  setFigmaRefreshLoading={setFigmaRefreshLoading}
                  taskId={taskId}
                  isTaskDetailPreview={isTaskDetailPreview}
                  figmaRefreshLoading={figmaRefreshLoading}
                  setSubTaskOpen={setSubTaskOpen}
                  setOpen={setOpen}
                  onClickTaskCheckbox={onClickTaskCheckBox}
                  onUpdateStatus={onChangeStatus}
                  loadData={loadData}
                  Opendeletemodel={Opendeletemodel}
                  onClickEdit={(task) => {
                    setIsFromSubList(true);
                    onClickEdit(task);
                  }}
                  onClickClone={onClickClone}
                  subTaskOpen={subTaskOpen}
                  isHoverSelect={isHoverSelect}
                  selectedSubTaskIds={selectedSubTaskIds}
                  hoveredSubTaskId={hoveredSubTaskId}
                />

                {mobile && (
                  <RightBlock
                    setAlertModalOpen={setAlertModalOpen}
                    taskId={taskId || ''}
                    onUpdateStatus={onChangeStatus}
                    setIsMilestonmodelopen={setIsMilestonmodelopen}
                    isTaskDetailPreview={isTaskDetailPreview}
                  />
                )}
                {renderActivitySection}
              </TaskDetailContainer>
              {selectedSubTaskIds.length > 0 && (
                <BulkActionControls
                  selectedTasks={selectedSubTaskIds}
                  currentProject={currentProject || undefined}
                  onBulkUpdateStatus={onBulkUpdateSubTaskStatus}
                  openSelectedDeleteModal={() => setSubTaskBulkDeleteModalOpen(true)}
                  onRemoveSelectedTasks={onRemoveSelectedSubTasks}
                  onBulkUpdateGroup={onBulkUpdateGroup}
                  isTaskDetail={true}
                />
              )}
            </HeaderBlock>
          </LeftBarView>
        </LeftBar>
        {attachment && !isCommentModal && (
          <RenderExistingFileV2 setAttachment={() => setAttachment(false)} onSelectFile={onSelectFile} />
        )}
        <Drawer
          placement='right'
          onClose={() => setAttachment(false)}
          open={attachment && isCommentModal}
          width='350px'>
          {attachment && isCommentModal && (
            <RenderExistingFileV2 setAttachment={() => setAttachment(false)} onSelectFile={onSelectFile} />
          )}
        </Drawer>
        {((attachment && isCommentModal) || !attachment) && !mobile && (
          <RightBlock
            taskId={taskId || ''}
            setAlertModalOpen={setAlertModalOpen}
            onUpdateStatus={onChangeStatus}
            setIsMilestonmodelopen={setIsMilestonmodelopen}
            isTaskDetailPreview={isTaskDetailPreview}
          />
        )}
        {/* Bottom Navigation */}
        <BottomSubNavigation
          rightElement={
            <>
              <BottomNavigationItem iconName='copy-link-icon' onClick={handleCopyTaskLink} />
              {renderDropdown()}
            </>
          }
        />
        <Modal open={open} maxWidth={'680px'} onClose={handleCancel} isCreateTask={true}>
          <CreateTaskModalV2
            loadData={loadData}
            onCancel={handleCancel}
            onProjectChange={(value: boolean) => handleProjectChange(value)}
            context={{ source: 'taskDetail', isTaskDetailPreview, isFromSubList }}
          />
        </Modal>

        <Modal open={deleteModelOpen} onClose={close} maxWidth={'334px'}>
          <DeleteModal
            onClose={close}
            onOk={deleteTask}
            loading={loading}
            modalTitle={`${
              isFromSubList
                ? 'Delete Task?'
                : (subTaskList?.length ?? 0) > 0
                ? `Delete this task and ${subTaskList?.length} subtasks?`
                : 'Delete Task?'
            }`}
            description={`${
              isFromSubList
                ? 'Are you sure you want to delete this task?'
                : (subTaskList?.length ?? 0) > 0
                ? 'This action will remove this task and all its connected subtasks.'
                : 'Are you sure you want to delete this task?'
            }`}
          />
        </Modal>
        <Modal open={!!deleteCommentId} onClose={closeDeleteCommentModal} maxWidth={'334px'}>
          <DeleteModal
            onClose={closeDeleteCommentModal}
            onOk={removeComment}
            loading={loading}
            modalTitle={`Delete comment?`}
            description={'Are you sure you want to delete this comment?'}
          />
        </Modal>
        {isEstimateDropdownOpen && (
          <OverLayDiv role='button' className='dropdown-overlay' onClick={() => setIsEstimateDropdownOpen(false)} />
        )}
      </Group>
      <Modal open={isOpenComment} onClose={Cancel} maxWidth={'692px'} isResponsiveMaxWidth={true}>
        {/* using tiptap editor */}
        <Commentmodal
          headerText='Update comment'
          ref={inlineRef}
          onClose={Cancel}
          sendComment={(files: CommentFilesInterface[], commentValue: string) =>
            taskCommentsRef.current?.submitComment(files, commentValue)
          }
          users={currentProject?.users?.filter((user) => !isEmpty(user?.id)) as UserInterface[]}
          uploadedFiles={uploadedFiles}
          setUploadedFiles={setUploadedFiles}
          valueContent={comment}
          setValueContent={(value: string) => setComment(value)}
          propsLoading={loading}
          setPropsLoading={(value: boolean) => setLoading(value)}
          onClickSelectFile={() => attachmentPage(true)}
          handleOpenSnapModal={handleOpenModal}
          disable={false}
          uploadFolder={buildCommentUploadFolder(projectId, taskId)}
        />
      </Modal>
      <Modal open={isMilestonemodelopen} onClose={isClosemodel} maxWidth={'462px'}>
        <MilestoneModal onClose={isClosemodel} projectId={taskDetails?.projectId || ''} />
      </Modal>
      <Modal open={alertModelOpen} onClose={closeAlertModal} maxWidth={'334px'}>
        <ConfirmationModal
          loading={alertLoading}
          onOk={onClickStopAndStartTime}
          onClose={closeAlertModal}
          modalTitle='Another timer is running.'
          description='Do you want to stop and start the timer on this task?'
        />
      </Modal>
      {isMediaRecordingSupported() && (
        <Modal open={isModalOpen} onClose={handleCloseModal} maxWidth={'258px'}>
          <SnapRecordModal handleCloseModal={handleCloseModal} />
        </Modal>
      )}
      <Modal open={subTaskBulkDeleteModalOpen} onClose={() => setSubTaskBulkDeleteModalOpen(false)} maxWidth={'334px'}>
        <DeleteModal
          onClose={() => setSubTaskBulkDeleteModalOpen(false)}
          modalTitle='Delete Tasks?'
          description='Are you sure you want to delete this selected tasks?'
          onOk={() => onBulkDeleteSubTasks(selectedSubTaskIds.map((item) => item.taskId))}
          loading={deleteLoading}
        />
      </Modal>
      <Modal open={isConfirmationModelOpen} onClose={closeConfirmationModal} maxWidth={'334px'}>
        <ConfirmationModal
          loading={confirmationLoading}
          cancelLoading={cancelLoading}
          onOk={onClickConfirm}
          onNo={onClickNo}
          onClose={closeConfirmationModal}
          modalTitle='Uncompleted Subtasks'
          description='Do you want to complete all these subtasks?'
        />
      </Modal>
      <Modal open={subTaskOpen} maxWidth={'598px'} onClose={() => setSubTaskOpen(!subTaskOpen)}>
        <SubtaskPopup
          onClose={() => setSubTaskOpen(!subTaskOpen)}
          currentProject={currentProject!}
          currentTask={taskDetails!}
        />
      </Modal>
      <Modal open={isOpen} onClose={cancelModel} maxWidth={'462px'}>
        <LinkFileModal onClose={cancelModel} modalData={LINK_FILE_DATA.ADDLINK} taskId={taskDetails?.id} />
      </Modal>
    </>
  );
};

export default observer(TaskDetail);
